import { FC, SVGAttributes } from 'react';

type FruitBlueberrySvgProps = SVGAttributes<SVGElement>;

export const FruitBlueberrySvg: FC<FruitBlueberrySvgProps> = ({ ...props }) => {
    return (
        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" {...props}>
            <path
                d="M32.4953 11.7933C26.4621 5.90201 17.0173 6.23022 10.984 12.1215C4.95078 18.0128 4.61467 27.2353 10.6479 33.1266C16.6811 39.0179 26.1259 38.6897 32.1592 32.7984C38.1924 26.9071 38.5285 17.6846 32.4953 11.7933Z"
                fill="#0775A0"
            />
            <path
                d="M27.1607 22.2436L26.5103 21.789C26.0683 21.4789 25.5104 21.3706 24.981 21.4904L24.023 21.707C23.0752 21.9203 22.2265 21.0916 22.445 20.1661L22.6668 19.2307C22.7895 18.7138 22.6786 18.1689 22.361 17.7374L21.8954 17.1023C21.2585 16.2342 21.9207 15.0297 23.0147 15.0707L23.4096 15.0855C24.0331 15.1101 24.6281 14.8311 24.9995 14.3404L25.302 13.9433C25.9103 13.1425 27.1825 13.2951 27.5724 14.2174L28.0161 15.2643C28.2077 15.7173 28.5774 16.0783 29.0412 16.2654L30.1134 16.6986C31.0579 17.0793 31.2142 18.3216 30.3941 18.9156L29.9874 19.211C29.4866 19.5753 29.2009 20.1562 29.2244 20.7634L29.2395 21.149C29.2815 22.2174 28.048 22.8639 27.159 22.242L27.1607 22.2436Z"
                fill="#175773"
            />
        </svg>
    );
};
